import { takeLatest, put, call, fork } from "redux-saga/effects";
import OnboardingService from "services/onboarding-service";
import { ONBOARDING_ACTIONS } from "constants/actions";
import {
    fetchedCasesList,
    failedFetchCasesList,
    fetchedWorkflowCaseDetail,
    failedFetchWorkflowCaseDetai,
    fetchedCasePendencyDetail,
    failedFetchCasePendencyDetail,
    fetchedCompanyBackground,
    failedFetchCompanyBackground,
    fetchedDeviationMatrix,
    failedFetchDeviationMatrix,
} from "actions";
import { message } from "antd";

function* fetchCasesList({ payload }) {
    try {

        const {data, error} = yield call(
            OnboardingService.fetchCasesListAPI,
            payload.stage,
            payload.page || 1,
            payload.page_size || 10,
            payload.type,
            payload.filters
        )
        if(!error){
            yield put(fetchedCasesList(payload.stage, payload.page, payload.page_size, data));
    
        }else{
            yield put(failedFetchCasesList(payload.stage, payload.page, payload.page_size, error));
        }
    } catch (error) {
        yield put(failedFetchCasesList(payload.stage, payload.page, payload.page_size, error));
    }
}

function* fetchCasesDetailAPI({ payload }) {
    try {

        const {data, error} = yield call(
            OnboardingService.fetchCasesDetailAPI,
            payload.id,
        )
        if(!error){
            yield put(fetchedWorkflowCaseDetail(data));
    
        }else{
            yield put(failedFetchWorkflowCaseDetai(error));
        }
    } catch (error) {
        if (error.non_field_errors) {
            message.error(error.non_field_errors[0]);
        } else {
            message.error("Something went wrong!");
        }
        yield put(failedFetchWorkflowCaseDetai(payload.stage, payload.page, payload.page_size, error));
    }
}


function* fetchCompanyBackgroundAPI({ payload }) {
    try {

        const {data, error} = yield call(
            OnboardingService.fetchCompanyBackgroundAPI,
            payload,
        )
        if(!error){
            yield put(fetchedCompanyBackground(data));
    
        }else{
            yield put(failedFetchCompanyBackground(error));
        }
    } catch (error) {
        if (error.non_field_errors) {
            message.error(error.non_field_errors[0]);
        } else {
            message.error("Something went wrong!");
        }
        yield put(failedFetchCompanyBackground(error));
    }
}

function* fetchDeviationMatrix({ payload }) {
    try {

        const {data, error} = yield call(
            OnboardingService.fetchDeviationMatrixApi,
            payload,
            )
        if(!error){
            yield put(fetchedDeviationMatrix(data));
    
        }else{
            yield put(failedFetchDeviationMatrix(error));
        }
    } catch (error) {
        if (error.non_field_errors) {
            message.error(error.non_field_errors[0]);
        } else {
            message.error("Something went wrong!");
        }
        yield put(failedFetchDeviationMatrix(error));
    }
}

function* fetchCasePendencyDetail({ payload }) {
    try {

        const {data, error} = yield call(
            OnboardingService.fetchCasePendency,
            payload.actionDetailId,
        )
        if(!error){
            yield put(fetchedCasePendencyDetail(data));
    
        }else{
            yield put(failedFetchCasePendencyDetail(error));
        }
    } catch (error) {
        yield put(failedFetchCasePendencyDetail(payload.stage, payload.page, payload.page_size, error));
    }
}

export default fork(function*() {
    yield takeLatest(ONBOARDING_ACTIONS.FETCH_CASES_LIST, fetchCasesList);
    yield takeLatest(ONBOARDING_ACTIONS.FETCH_WORKFLOW_CASE_DETAIL, fetchCasesDetailAPI);
    yield takeLatest(ONBOARDING_ACTIONS.FETCH_CASE_PENDENCY_DETAIL, fetchCasePendencyDetail);
    yield takeLatest(ONBOARDING_ACTIONS.FETCH_COMPANY_BACKGROUND, fetchCompanyBackgroundAPI);
    yield takeLatest(ONBOARDING_ACTIONS.FETCH_DEVIATION_MATRIX, fetchDeviationMatrix);

});